export default class LivestreamGtmEvent {
  constructor(options = {}){
    this._tech = options.tech;
    this._data = options.data;
  }

  bindEvents(){
    this.bindAdStart();
    this.bindStart();
    this.bindBuffer();
    this.bindMeta();
    this.bindFullscreen();
    this.bindBitrateChange();
  }

  tech(){
    return this._tech;
  }

  data(){
    return this._data;
  }

  bindAdStart(){
    this.tech().on('vp-livestream-adstart', function(e){
      dataLayer.push({
        "event" : "impression",
        "ads_id" : e.adUUID,
        "feature_location" : "pre-roll",
        "feature_name" : "ads.play",
        "ads_location" : "live."+e.id,
        "playback_location" : e.embed == "false" ? "direct" : "embed"
      });
    });
  }

  bindStart(){
    this.tech().on('vp-livestream-start', function(e){
      dataLayer.push({
        "event" : "start",
        "live_id" : e.id,
        "feature_name" : "live.play",
        "feature_location" : "live." + e.streamType,
        "session_id": `${this.getCookie("ahoy_visit")}/${this.getCookie("ahoy_visitor")}`,
        "playback_location" : e.embed == "false" ? "direct" : "embed"
      });
    }.bind(this));
  }

  bindBuffer() {
    this.tech().on('vp-livestream-buffer', function(e){
      dataLayer.push({
        "event" : "buffer",
        "live_id" : e.id,
        "feature_name" : "live.play",
        "feature_location" : "live." + e.streamType,
        "session_id": `${this.getCookie("ahoy_visit")}/${this.getCookie("ahoy_visitor")}`,
        "playback_location" : e.embed == "false" ? "direct" : "embed"
      });
    }.bind(this));
  }

  bindMeta() {
    this.tech().on('vp-livestream-meta', function(e){
      dataLayer.push({
        "event" : "meta",
        "live_id" : e.id,
        "feature_name" : "live.play",
        "feature_location" : "live." + e.streamType,
        "session_id": `${this.getCookie("ahoy_visit")}/${this.getCookie("ahoy_visitor")}`,
        "playback_location" : e.embed == "false" ? "direct" : "embed"
      });
    }.bind(this));
  }

  bindFullscreen() {
    this.tech().on('vp-fullscreen-change', function(e){
      if(this.tech().plugin().instance().isFullscreen()) {
        dataLayer.push({
          "event" : "size",
          "live_id" : e.id,
          "feature_name" : "live.play",
          "feature_location" : "fullsize",
          "playback_location" : e.embed == "false" ? "direct" : "embed"
        });
      }
    }.bind(this));
  }

  bindBitrateChange(){
    this.tech().on("vp-bitrate-change", function(e){
      dataLayer.push({
        "event" : "click",
        "live_id" : this.data().videoId(),
        "feature_name" : "bitrate",
        "feature_location" : e.height,
        "playback_location" : this.data().embed() === "false" ? "direct" : "embed"
      });
    }.bind(this));
  }

  getCookie(name) {
    var i, c;
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (i = 0; i < ca.length; i++) {
      c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        return window.unescape(c.substring(nameEQ.length, c.length));
      }
    }
    return null;
  }
}
